/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React, { useCallback, useEffect, useState } from 'react';
import {
  VegaTabGroup,
  VegaButtonLink
} from '@heartlandone/vega-react';
import MessageTabGroupPanel from './MessageTabGroupPanel';
import { useDispatch } from 'react-redux';
import { initializeMessageState } from 'Slices/Header/messageSlice';
import { getMessages } from 'Chores/request';
import { getUserInfo } from 'Chores/utils';
import { useKeycloak } from '@react-keycloak/web';

const MessageTabGroup = () => {
  const dispatch = useDispatch();
  const { keycloak } = useKeycloak();
  const userInfo = getUserInfo(keycloak?.idTokenParsed?.sub);
  const userId = userInfo?.userId || userInfo?.id || '';
  const [localMessageList, setLocalMessageList] = useState([]);
  const [selectedTab, setSelectedTab] = useState('allLists');
  const [messageSource, setMessageSource] = useState({ allLists: [], unread: [], system: [] });
  const [allListsCount, setAllListsCount] = useState(0);
  const [systemCount, setSystemCount] = useState(0);
  const [unreadCount, setUnreadCount] = useState(0);

  const isMessageRead = useCallback((message) => {
    if (Object.prototype.hasOwnProperty.call(message, 'isRead')) {
      return message.isRead;
    }
    return true;
  }, []);

  const goBack = () => {
    window.history.back();
  };

  const decorateMessageList = useCallback((messages) =>
    messages.map((message) => {
      const read = isMessageRead(message);
      return {
        ...message,
        read,
        selected: false,
        trigger: false,
        backgroundColor: read ? 'bg-primary' : 'bg-page'
      };
    }), [isMessageRead]);

  const tabItems = [
    {
      label: 'All Messages',
      dataTarget: 'allLists',
      counterBadge: { color: `bg-action`, count: allListsCount }
    },
    {
      label: 'Unread',
      dataTarget: 'unread',
      counterBadge: { color: `bg-action`, count: unreadCount }
    },
    {
      label: 'System',
      dataTarget: 'system',
      counterBadge: { color: `bg-action`, count: systemCount }
    }];

  const initializeState = (e) => {
    const newTab = e.detail;
    setSelectedTab(newTab);
    dispatch(initializeMessageState());
    const sourceList = messageSource[newTab] || [];
    setLocalMessageList(decorateMessageList(sourceList));
  };

  useEffect(() => {
    const fetchMessages = async () => {
      if (!userId) {
        setMessageSource({ allLists: [], unread: [], system: [] });
        setLocalMessageList([]);
        dispatch(initializeMessageState());
        return;
      }
      try {
        const response = await getMessages(userId);
        const allMessages = response || [];
        const nextSource = {
          allLists: allMessages,
          unread: allMessages.filter((message) => !isMessageRead(message)),
          system: allMessages.filter((message) => message.messageType === 'system')
        };
        setMessageSource(nextSource);
        setLocalMessageList(decorateMessageList(nextSource.allLists));
        setSelectedTab('allLists');
        dispatch(initializeMessageState());
      } catch (error) {
        setMessageSource({ allLists: [], unread: [], system: [] });
        setLocalMessageList([]);
        dispatch(initializeMessageState());
      }
    };

    fetchMessages();
  }, [decorateMessageList, dispatch, isMessageRead, userId]);

  useEffect(() => {
    setAllListsCount(messageSource.allLists.filter((message) => !message.isRead).length);
    setSystemCount(messageSource.system.filter((message) => !message.isRead).length);
    setUnreadCount(messageSource.unread.length);
  }, [messageSource]);

  return (
    <>
      <VegaButtonLink icon="fas fa-angle-left" onVegaClick={goBack}>
        Back
      </VegaButtonLink>
      <VegaTabGroup
        tabItems={tabItems}
        selectedTabDataTarget={selectedTab}
        id="message-tab-group"
        onVegaClick={initializeState}
      >
        {tabItems.map((item) =>
          <MessageTabGroupPanel
            key={item.dataTarget}
            item={item}
            localMessageList={localMessageList}
            setLocalMessageList={setLocalMessageList}
            messageSource={messageSource}
            setMessageSource={setMessageSource}
            selectedTab={selectedTab}
          />)}
      </VegaTabGroup>
    </>
  );
};

MessageTabGroup.propTypes = {};

export default MessageTabGroup;
